import React, { createContext, useMemo, forwardRef } from 'react';
import {
  chakra, StylesProvider, useMultiStyleConfig, useRadioGroup,
} from '@chakra-ui/react';

export const radioButtonsContext = createContext(null);

export const RadioButtonGroup = forwardRef((props, ref) => {
  const {
    name,
    value,
    onBlur,
    variant,
    onChange,
    children,
    isInvalid,
    ...contentProps
  } = props;

  const multiStyleConfig = useMultiStyleConfig('RadioButtonGroup', { variant });

  const { getRootProps, getRadioProps } = useRadioGroup({
    name,
    value,
    onChange,
  });

  const group = getRootProps({ ref });

  const radioButtonValue = useMemo(() => ({
    isInvalid,
    getRadioProps,
    ref,
  }), [isInvalid, getRadioProps]);

  return (
    <radioButtonsContext.Provider value={radioButtonValue}>
      <StylesProvider value={multiStyleConfig}>
        <chakra.div
          __css={multiStyleConfig.buttonGroup}
          {...group}
          {...contentProps}
        >
          {children}
        </chakra.div>
      </StylesProvider>
    </radioButtonsContext.Provider>
  );
});
